import noSeriesImage from '../../asset/image/no-series.png'
import React from 'react'
import { Link } from 'react-router-dom'
import { OutlinedButton } from 'src/component/ui/button'

export const NoProfileSeriesAwards = (): React.ReactElement => {
  return (
    <div>
      <p className="font-roboto-condensed-medium text-ivory">
        You have not won any medal yet! Please explore our list of series!
      </p>
      <div className="relative flex items-center justify-center min-h-[270px] w-full overflow-hidden rounded-md">
        <img src={noSeriesImage} alt="" className="absolute inset-0 w-full h-full object-cover z-0" />
        <OutlinedButton asChild className="relative z-10 border-ivory text-ivory">
          <Link to="/programmes">SEE ALL SERIES</Link>
        </OutlinedButton>
      </div>
    </div>
  )
}
